function key(programSlug) {
  return `epl_prog_${programSlug}_tests`;
}

export function getTests(programSlug) {
  try {
    return JSON.parse(localStorage.getItem(key(programSlug)) || "{}");
  } catch {
    return {};
  }
}

export function saveTest(programSlug, unitSlug, data) {
  const t = getTests(programSlug);
  t[unitSlug] = { ...data, createdAt: Date.now() };
  localStorage.setItem(key(programSlug), JSON.stringify(t));
  return t;
}
